
import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/productsupplierparameter`;

export const productSupplyParamService = {

    getProductSupplyParameter: async function (supplierCode: any, locationCode: any, productCode: any) {
        return axios.get(`${GATEWAY_URL}/product_supplier_parameters`, {
            params: {
                SupplierCode: supplierCode,
                LocationCode: null,
                ProductCode: productCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getSupplierLookups: async function (loadOptions: any) {
        return axios.get(`${GATEWAY_URL}/product_suppliers`, {
        })
            .then((response) => {
                return response.data;
            });
    },
    getSupplierLookupByKey: async function (supplierCode: any) {
        return axios.get(`${GATEWAY_URL}/product_suppliers`, {
        })
            .then((response) => {
                return response.data[0];
            });
    },

    getLocationLookups: async function (supplierCode: any) {
        return axios.get(`${GATEWAY_URL}/product_supplier_locations`, {
            params: {
                SupplierCode: supplierCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getProductLookups: async function (supplierCode: any, locationCode: any) {
        return axios.get(`${GATEWAY_URL}/products`, {
            params: {
                SupplierCode: supplierCode,
                LocationCode: locationCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },




    deleteProductSupplyParameter: async function (id: string) {
        return axios.get(`${GATEWAY_URL}/delete_product_supplier_parameters`, {
            params: {
                Id: id
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    updateProductSupplyParameter: async function (key: any, values: any) {
        return axios.post(`${GATEWAY_URL}/save_product_supplier_parameters`, values)
            .then((response) => {
                return response.data;
            });
    },


    updateProductSupplyParameterBatch: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/save_product_supplier_parameters`, values)
            .then((response) => {
                return response.data;
            });
    },


    getSupplierForLocation: async function (LocationCode: any) {
        return axios.get(`${GATEWAY_URL}/product_suppliers`, {
            params: {
                LocationCode: LocationCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },


    //  getProductsForSupplier: async function (supplierCode: any, locationCode: any) {
    //     return axios.get(`${GATEWAY_URL}/product_detail_list`, {
    //         params: {
    //             SupplierCode: supplierCode,
    //             LocationCode: locationCode
    //         }
    //     })
    //         .then((response) => {
    //             return response.data;
    //         });
    // },



    getProductsForSupplier: async function (supplierCode: any, locationCode: any, rows: any) {
        const response = await axios.get(`${GATEWAY_URL}/product_detail_list`, {
            params: {
                SupplierCode: supplierCode,
                LocationCode: locationCode
            }
        })

        const queryResultData = response.data ?? [];
        const responseData: any = [];
  
        queryResultData.forEach((element: any) => {
            if (rows.filter((x: any) => x.data.productCode == element.productCode).length == 0) {
                responseData.push(element)
            }
        });
 
        return responseData;
    }


}

